import { NEW_CREDIT_CARD_VALUE } from '../../../../constants';
import {
    GatewayPaymentFieldsForNewCard,
    GatewayPaymentFieldsForPreauth,
    GatewayPaymentFieldsSelectedCard,
    GatewayPaymentFormValues,
} from './schema';

export const areNewPaymentCardFormValues = (
    values: GatewayPaymentFormValues
): values is GatewayPaymentFieldsForNewCard =>
    'paymentMethodId' in values && values.paymentMethodId === NEW_CREDIT_CARD_VALUE;

export function hasPaymentMethodId(
    values: GatewayPaymentFormValues
): values is GatewayPaymentFieldsForNewCard | GatewayPaymentFieldsSelectedCard {
    return 'paymentMethodId' in values;
}

export function hasPreAuthorizationId(values: GatewayPaymentFormValues): values is GatewayPaymentFieldsForPreauth {
    return 'preAuthorizationId' in values;
}
